<template>
  <div class="postPreview">
    <div class="previewContainer">
      <AreYouBeingScammed/>
    </div>
    <div class="continueLink">
      <router-link to="/blog/AreYouBeingScammed">Continue reading... </router-link>
    </div>
  </div>
</template>

<script>
import AreYouBeingScammed from './AreYouBeingScammed'

export default {
  name: 'PostPreview',
  components: { AreYouBeingScammed }
}
</script>
<style lang="scss" scoped>
  h2 {
    a {
      color: $primary-dark-color;
    }
  }
  .postPreview {
    .previewContainer {
      max-height: 580px;
      overflow: hidden;
    }

    a {
      font-size: .9em;
      opacity: 1;
    }

    .continueLink {
      background-color: #fdfdfd;
      padding: 5px;
      box-shadow: -1px -19px #fdfdfd;
      opacity: .9;
    }
  }
</style>
